/** Scope values for prompt screens (tabs + API `scope`). */
export const PROMPT_SCREEN_SCOPES = [
  { value: 'specialty', label: 'Specialty' },
  { value: 'service_request', label: 'Service request' },
  { value: 'agent', label: 'Agent' },
  { value: 'magicflow', label: 'Magicflow' },
];

export const scopeLabel = (value) =>
  PROMPT_SCREEN_SCOPES.find((o) => o.value === value)?.label ?? value ?? '—';
